<div class="overview-container" [ngClass]="{'confirmation-padding': isConfirmationPage,'overview-page': !isConfirmationPage}">
  <div class="overview-header">
    <div class="overview-title">
      @if (isConfirmationPage) {
      <div class="oab-header">
        <div class="page-header">Online Appointment Booking</div>
      </div>     
      <span i18n>APPOINTMENT CONFIRMED</span>
      } @else {
      <span i18n clas="title">Overview</span>
      }
    </div>
    <p class="overview-description">
      @if (isConfirmationPage) {
      <span i18n>Your service appointment has been confirmed.</span>
      } @else {
      <span i18n>Check your appointment details and confirm appointment request.</span>
      }
    </p>

  </div>

  <div class="overview-content">
    <h3 class="section-title" i18n>Service Appointment</h3>

    <div [ngClass]="{ 'confirmation-bg': isConfirmationPage }">

      @if(isConfirmationPage){
      <div class="detail-section">
        <div class="detail-label" i18n>Appointment No.</div>
        <div class="detail-content">
          <div class="detail-subvalue">No.{{ appointment?.documentNo || 'N/A' }}</div>
        </div>
      </div>
      }

      <!-- Date and Time Section -->
      <div class="detail-section">
        <div class="detail-label" i18n>Date and time</div>
        <div class="detail-content">
          <div class="detail-value">{{ getFormattedDate() }}</div>
          <div class="detail-value">{{ getFormattedTime() }}</div>
          <div class="detail-subvalue">{{ getAdvisorName() }}</div>
        </div>
      </div>

      <!-- Customer Section -->
      <div class="detail-section">
        <div class="detail-label" i18n>Customer</div>
        <div class="detail-content">
          <div class="detail-value">{{ getCustomerName() }}</div>
          <div class="detail-subvalue">{{ getCustomerPhone() }}</div>
          <div class="detail-subvalue">{{ getCustomerEmail() }}</div>
          @if(!isConfirmationPage){
          <div class="change-link" (click)="onChangeCustomer()" i18n>Change</div>
          }
        </div>
      </div>

      <!-- Vehicle Section -->
      <div class="detail-section vehicle-section">
        <div class="detail-label" i18n>Vehicle</div>
        <div class="detail-content">
          <div class="detail-value">{{ getVehicleModel() }}</div>
          <div class="detail-subvalue">{{ getVehicleVin() }}</div>
          <div class="detail-subvalue">{{ getVehicleLicense() }}</div>
        </div>
        @if (isConfirmationPage) {
        <span class="vehicle-confirmation">
          <img src="assets/common/check_circle.png" alt="Confirmation Success" />
        </span>
        }
      </div>

      <!-- Service Centre Section -->
      <div class="detail-section">
        <div class="detail-label" i18n>Service Centre</div>
        <div class="detail-content">
          <div class="detail-value">{{ getServiceCenterName() }}</div>
          <div class="detail-subvalue">{{ getServiceCenterAddress() }}</div>
        </div>
      </div>

      <!-- Services Section -->
      <div class="services-header">
        <div class="detail-label" i18n>Services</div>
      </div>

      @if (selectedServices.length > 0) {
      @for (service of selectedServices; track service.id) {
      <div class="service-row">
        <div class="service-details">
          <div class="service-name">{{ service.name }}</div>
        </div>
        <div class="service-price">
          @if (service.unitPrice && (service.unitPrice.grossPrice || service.unitPrice.netPrice)) {
          <span>{{ (service.unitPrice.grossPrice || service.unitPrice.netPrice) |
            currency:service.unitPrice.currency:'symbol':'1.0-0' }}</span>
          } @else {
          <span class="calculated-price" i18n>calculated at service center</span>
          }
          @if (service.unitPrice && (service.unitPrice.grossPrice || service.unitPrice.netPrice)) {
          <div class="price-note" i18n>{{ service.unitPrice.grossPrice ? '(incl. VAT)' : '(excl. VAT)' }}</div>
          }
        </div>
      </div>
      }
      } @else {
      <div class="service-row">
        <div class="service-name" i18n>No services selected</div>
        <div class="service-price">-</div>
      </div>
      }
    </div>
  </div>
  @if (isConfirmationPage) {
  <div class="footer">
    <button mat-stroked-button color="primary" class="close-btn" (click)="close()" i18n>
      Close
    </button>
  </div>
  }
</div>